import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";

export const adminGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRole("ADMIN")) {
    return true;
  } else {
    router.navigate(["/signup"]);
    return false;
  }
};
